import { useState, useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { v4 as uuidv4 } from "uuid";
import "react-quill/dist/quill.snow.css";
import * as queries from "../../graphql/queries";
import * as mutations from "../../graphql/mutations";
import { useNavigate } from "react-router-dom";
import "./NewPrivacyPolicy.css";
import { Checkbox } from "../Checkbox/Checkbox";
import { InputForm } from "../InputForm/InputForm";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { PolicyType } from "../PrivacyPolicy/PrivacyPolicType";
import { Notification } from "../Notification/Notification";

type OptionType = {
  value: string;
  label: string;
};

const options: OptionType[] = [
  {
    value: "ti",
    label: "Travel Insurance",
  },
  { value: "tmc", label: "Travel Money Card" },
  { value: "app", label: "Travel App" },
];

export const NewPrivacyPolicy = () => {
  const [allPolicies, setAllPolicies] = useState<any>();
  const [policy, setPolicy] = useState({
    id: "",
    policyType: "",
    header: "",
    body: "",
    isActive: false,
  } as PolicyType);
  const [toastTitle, setToastTitle] = useState("" as string);
  const [toastDescription, setToastDescription] = useState("" as string);
  const [showToast, setShowToast] = useState(false as boolean);

  const handleChangeText = (value: string, name: string) => {
    setPolicy((policy) => {
      return {
        ...policy,
        [name]: value,
      };
    });
  };

  const handleDescription = (event) => {
    let newBody = event.target.value;
    setPolicy((policy) => {
      return {
        ...policy,
        body: newBody,
      };
    });
  };

  const handleNotificationClose = () => {
    setShowToast(false);
  };

  const handleSelectChange = (selected) => {
    setPolicy((policy) => {
      return {
        ...policy,
        policyType: selected.value,
      };
    });
  };
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  const fetchPolicies = async () => {
    const policies = await API.graphql(graphqlOperation(queries.getPolicy));
    console.log("DISPLAY THE POLICIES:" + JSON.stringify(policies));
  };

  useEffect(() => {
    fetchPolicies();
  }, []);

  const handleSubmitPolicy = async () => {
    try {
      policy.id = uuidv4();
      console.log("Policy we are sending: " + JSON.stringify(policy));
      await API.graphql(
        graphqlOperation(mutations.createPolicy, {
          policy,
        })
      );
      setToastTitle("Success!");
      setToastDescription("You successfully created a policy");
      setShowToast(true);
    } catch (e) {
      console.log(e);
    }
  };

  const handleCheckValue = (event: React.MouseEvent<HTMLInputElement>) => {
    const currentTarget = event.target as HTMLInputElement;
    const checked = currentTarget.checked;
    const name = currentTarget.name;
    setPolicy((policy) => {
      return {
        ...policy,
        [name]: checked,
      };
    });
  };

  return (
    <div>
      <h1 className="title">Add New Policy</h1>
      <div className="formContainer">
        <div className="formItem">
          <InputForm
            name="header"
            ariaLabel="Title"
            size="lg"
            onChange={handleChangeText}
            labelText="Policy Header"
            controlId="formMessages"
            defaultValue={policy?.header}
          />
        </div>
        <div className="formItem">
          <div className="description-title">Select Policy Type</div>
          <Select
            defaultValue={{
              value: "",
              label: "Please select a Policy Type",
            }}
            options={options}
            onChange={handleSelectChange}
          />
        </div>
        <div className="formItem">
          <div className="description-title">Policy Body</div>
          <textarea
            value={policy.body}
            className="description"
            onChange={handleDescription}
            defaultValue={policy?.body}
          />
        </div>
        <div className="formItem">
          <span>
            <Checkbox
              label="Is Active"
              name="isActive"
              handleCheck={handleCheckValue}
              defaultChecked={false}
            />
          </span>
        </div>
        <div className="formItem">
          <Button
            type="button"
            className="btn btn-danger save-button"
            onClick={handleSubmitPolicy}
          >
            Save
          </Button>
          <Button type="button" className="btn btn-secondary" onClick={goBack}>
            Cancel
          </Button>
        </div>
      </div>
      <div className="notificationContainer">
        <Notification
          show={showToast}
          timer={4000}
          position="bottom-end"
          title={toastTitle}
          description={toastDescription}
          autohide={true}
          handleClose={handleNotificationClose}
        />
      </div>
    </div>
  );
};
